import { DEFAULT_RAW_FONTSIZE } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';

/**
 * 查找替换功能，文本默认背景色
 */
export const SEARCH_COLOR = 'rgba(242, 226, 0, 0.5)';
export const HIGHLIGHT_COLOR = 'rgba(241, 185, 0, 1)';

const FONT_SCALE = 2;
export const DEFAULT_FONTSIZE = DEFAULT_RAW_FONTSIZE * FONT_SCALE;
export const DEFAULT_FONT_PERCENT = 1.3;

export const TEXT_CURSOR = 'text';
export const VERTICAL_TEXT_CURSOR = 'vertical-text';

// 默认字体列表。Calibri字体是office的西文默认字体，只会对西文生效
export const DEFAULT_FONT_FAMILY = ['Calibri', 'PingFang SC', 'Microsoft YaHei', '黑体', '宋体', 'TdocsUncommon', 'sans-serif'];
// 针对不同文字脚本类型设置默认字体
export const SPECIFIC_DEFAULT_FONT_FAMILY = {
    Han: ['PingFang SC', 'Microsoft YaHei', '黑体', '宋体', 'TdocsUncommon', 'sans-serif'],
};
